import debug from '../../utils/console'

const logger = debug.extend('utils:isCurrentlyAtHomeTab')

export function isCurrentlyAtHomeTab(): boolean {
  try {
    const searchUrl = window.location.href
    const url = new URL(searchUrl)
    const params = new URLSearchParams(url.search)
    return params.has('pinned') && params.get('pinned') === 'true'
  } catch (e) {
    logger.error(e)
    return false
  }
}
